import CbRow from './src/row.vue';

CbRow.install = function(Vue) {
  Vue.component(CbRow.name, CbRow);
};

export default CbRow;
